/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { get, post } from '../../../services/GenesisApi';
import {
  COUNTERPARTYAPI,
  COUNTERPARTYSEARCHAPI,
} from '../../../constants/Maintenance';
import { ICounterpartyData } from '../../../types/Counterparty.type';

interface IData {
  data: ICounterpartyData[];
  totalRecords: number;
}

interface ICounterpartyPayload {
  counterpartys: ICounterpartyData[];
  count: number;
}

export const getCounterpartyData = createAsyncThunk(
  'counterpartyData/getCounterpartyData',
  async () => {
    return get(COUNTERPARTYAPI, {})
      .then((response) => {
        return response.data || [];
      })
      .catch((error) => {
        throw error;
      });
  }
);

export const getCounterpartyDataAdvSearch = createAsyncThunk(
  'counterpartyData/getCounterpartyDataAdvSearch',
  async (requestBody: any) => {
    return post(COUNTERPARTYSEARCHAPI, requestBody)
      .then((response) => {
        return response.data || [];
      })
      .catch((error) => {
        throw error;
      });
  }
);

export interface ICounterpartyState {
  counterpartyData: ICounterpartyData[];
  counterpartyDataAdvSearch: IData;
  isLoading: boolean;
}

export const initialState: ICounterpartyState = {
  counterpartyData: [],
  counterpartyDataAdvSearch: {
    data: [],
    totalRecords: 0,
  },
  isLoading: false,
};

const CounterpartyData = createSlice({
  name: 'counterpartyActions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        getCounterpartyDataAdvSearch.pending,
        (state: ICounterpartyState) => {
          state.isLoading = true;
        }
      )
      .addCase(
        getCounterpartyDataAdvSearch.fulfilled,
        (
          state: ICounterpartyState,
          { payload }: PayloadAction<ICounterpartyPayload>
        ) => {
          state.counterpartyDataAdvSearch.data = payload?.counterpartys;
          state.counterpartyDataAdvSearch.totalRecords = payload?.count;

          state.isLoading = false;
        }
      )
      .addCase(
        getCounterpartyDataAdvSearch.rejected,
        (state: ICounterpartyState) => {
          state.isLoading = false;
        }
      )
      .addCase(getCounterpartyData.pending, (state: ICounterpartyState) => {
        state.isLoading = true;
      })
      .addCase(
        getCounterpartyData.fulfilled,
        (
          state: ICounterpartyState,
          { payload }: PayloadAction<ICounterpartyData[]>
        ) => {
          state.counterpartyData = payload;

          state.isLoading = false;
        }
      )
      .addCase(getCounterpartyData.rejected, (state: ICounterpartyState) => {
        state.isLoading = false;
      });
  },
});

export const counterpartyActions = CounterpartyData.actions;
export default CounterpartyData.reducer;
